module.exports = __webpack_public_path__ + "static/img/project_04.d34abd68.png";